export default __webpack_public_path__ + "static/media/exactagconverter.77dfba93.svg";